export const charSelected = (char) => ({
	type: 'CHAR_SELECTED',
	char
});

export const charInc = (charInc) => ({
	type: 'CHAR_INC',
	charInc
});

export const charCase = (charCase) => ({
	type: 'CHAR_CASE',
	charCase
});

export const charClear = (charClearState) => ({
	type: 'CHAR_CLEAR',
	charClearState
});


// WEBPACK FOOTER //
// ./src/actions/char.js